module.exports = __webpack_public_path__ + "img/calendar.d332bbe4.svg";